import React from 'react';
import { PositionsTableSkeleton } from './components/PositionsTableSkeleton';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { ErrorState } from '../../../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';

interface PositionsTableErrorProps {
  onRetry?(): void;
  isEmbeddedMobile: boolean;
}

export const PositionsTableError: React.FC<PositionsTableErrorProps> = ({
  onRetry,
  isEmbeddedMobile,
}) => {
  return (
    <PositionsTableSkeleton isEmbeddedMobile={isEmbeddedMobile}>
      <Box p="56" bg="bg">
        <ErrorState onAction={onRetry} />
      </Box>
    </PositionsTableSkeleton>
  );
};
